import { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectSubscribedUserIds } from '../store/features/StatusSubscription/statusSubscriptionSlice';
import { useUserStatuses } from '../hooks/useUserStatuses';

interface StatusProviderProps {
    children: ReactNode;
}

/**
 * StatusProvider sits at the app root and fetches statuses for all subscribed users.
 * Components use useStatusSubscription to register which users they need status updates for.
 * This ensures we only make ONE status query for all components combined.
 */
export const StatusProvider = ({ children }: StatusProviderProps) => {
    const subscribedUserIds = useSelector(selectSubscribedUserIds);

    const { isError } = useUserStatuses({
        userIds: subscribedUserIds,
        skip: subscribedUserIds.length === 0
    });

    useEffect(() => {
        if (isError) {
            console.error('[StatusProvider] Error fetching user statuses');
        }
    }, [isError]);

    // This provider doesn't render anything special, just manages the status fetching
    return <>{children}</>;
};

export default StatusProvider;
